import React, {
  createContext,
  useState,
  useEffect,
  useContext,
} from "react";
import { useMsal } from '@azure/msal-react';
import useFetchWithMsal from "../hooks/useFetchWithMsal";
import { protectedResources } from "../authConfig";
import { isTestEnv } from "../globals";

const BranchesContext = createContext();

export const BranchesProvider = ({ children }) => {
  isTestEnv && console.log("BranchesProvider");

  const { accounts } = useMsal();
  const [allBranches, setAllBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const { error, execute } = useFetchWithMsal({
    scopes: protectedResources.apiScopes.scopes.read,
  });

  useEffect(() => {
    isTestEnv && console.log("fetchBranches");

    const fetchBranches = async () => {
      isTestEnv && console.log("fetchBranches");

      try {
        const branchesResponse = await execute(
          "GET",
          `${process.env.REACT_APP_BACKEND_BASE_URL}/api/branch/`
        );
        if (branchesResponse) {
          const allBranchesList = await branchesResponse.branchesList;

          isTestEnv && console.log("allBranchesList", allBranchesList);

          if (allBranchesList) {
            setAllBranches(allBranchesList);
            isTestEnv && console.log("allBranchesList", allBranchesList);
          }
        }
      } catch (error) {
        isTestEnv && console.error("Failed to fetch branches", error);
      } finally {
        setLoading(false);
      }
    };

    if (accounts.length > 0) {
      fetchBranches();
    } else {
      setLoading(false);
    }
  }, [accounts.length, execute]);

  return (
    <BranchesContext.Provider value={{ allBranches, setAllBranches, loading }}>
      {children}
    </BranchesContext.Provider>
  );
};

export const useAllBranches = () => useContext(BranchesContext);
